import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">热播榜单</h2>
          <p className="text-foreground-600 text-sm">全网热播影视排行，每日更新热度数据</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl font-bold text-lg ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-base font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">{item.category}</span>
                </div>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-2">{item.desc}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'}`}></i>
                  <span>{item.heat} 热度</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}